import { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { login } from "../../../redux/auth";
import Ripple from "../../UI/spinners/ripple/Ripple";
import axios from "../../../axios/axios";
import { parseJWT } from "../../../helpers/auth";

const OTPBox = ({ username, setFormData }) => {
  const [otp, setOtp] = useState(new Array(4).fill(""));

  // mask username
  const usernameMask = `01*****${username.substr(username.length - 4)}`;

  // handle OTP change
  const otpChangedHandler = (event, index) => {
    if (isNaN(event.target.value)) {
      return false;
    } else {
      setOtp((prevOtp) =>
        prevOtp.map((otp, idx) => (idx === index ? event.target.value : otp))
      );

      // autofocus the next input
      event.target.nextSibling?.focus();
    }
  };

  // handle backspace keydown
  const submitButtonRef = useRef();
  const keyDownHandler = (event, index) => {
    if (event.key === "Backspace") {
      setOtp((prevOtp) =>
        prevOtp.map((otp, idx) =>
          index - idx === 1 || idx === index ? "" : otp
        )
      );

      event.target.previousSibling?.focus();
    } else if (event.key === "Enter") {
      submitButtonRef.current.click();
    }
  };

  // handle reset button
  const resetOtpHandler = (event) => {
    event.preventDefault();
    setOtp((prevOtp) => prevOtp.map(() => ""));
  };

  // handle verify button
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const verifyOTPHandler = (event) => {
    event.preventDefault();
    setLoading(true);

    axios({
      method: "POST",
      url: "mechanic/loginMechanic",
      data: { username, otp: otp.join("") },
    })
      .then((res) => res.data)
      .then((data) => {
        setLoading(false);
        const user = parseJWT(data.jwtToken);
        window.localStorage.setItem("token", data.jwtToken);
        dispatch(login(user));
      })
      .catch((err) => {
        setLoading(false);
        if (err?.response?.status === 401) {
          setFormData((prevData) => ({
            ...prevData,
            error: "رقم غير صحيح",
          }));
        }
      });
  };

  return (
    <div>
      <p className="mb-4 text-2xl">
        تم ارسال كود الي رقم{" "}
        <span dir="ltr" className="numeric-content">
          {usernameMask}
        </span>
      </p>
      <div dir="ltr" className="mb-10 flex max-w-full gap-4 justify-evenly">
        {otp.map((otpField, index) => (
          <input
            autoFocus={index === 0}
            key={index}
            value={otpField}
            maxLength={1}
            className="text-center text-2xl border border-gray-500 w-16 h-16 rounded focus:border-dark-blue numeric-content"
            onChange={(event) => otpChangedHandler(event, index)}
            onKeyDown={(event) => keyDownHandler(event, index)}
            onFocus={(event) => event.target.select()}
          />
        ))}
      </div>

      <div className="flex gap-2 justify-center">
        <button
          onClick={verifyOTPHandler}
          disabled={loading}
          className="px-10 py-4 text-white text-2xl rounded bg-dark-blue disabled:bg-light-gray disabled:cursor-not-allowed"
          ref={submitButtonRef}
          type="submit"
        >
          {loading ? <Ripple className="border border-dark-blue" /> : "تأكيد"}
        </button>
        <button
          onClick={resetOtpHandler}
          className="px-10 py-4 rounded bg-light-gray text-2xl"
          type="button"
        >
          مسح
        </button>
      </div>
    </div>
  );
};

export default OTPBox;
